import { useEffect } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { Route, Routes, useLocation } from "react-router-dom";

import AboutUs from "./pages/AboutUs";
import AccountsTypes from "./pages/AccountsTypes";
import Home from "./pages/Home";
import Markets from "./pages/Markets";
import Support from "./pages/Support";

const pageAnimation = {
  initial: { opacity: 0 },
  animate: { opacity: 1, transition: { duration: 0.45 } },
  exit: { opacity: 0, transition: { duration: 0.25 } },
};

const PageWrapper = ({ children }) => (
  <motion.div
    initial={pageAnimation.initial}
    animate={pageAnimation.animate}
    exit={pageAnimation.exit}
    className="min-h-[calc(100vh-52px)] bg-white"
  >
    {children}
  </motion.div>
);

export default function AnimatedRoutes() {
  const location = useLocation();

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "auto" });
  }, [location.pathname]);

  return (
    <AnimatePresence mode="wait">
      <Routes location={location} key={location.pathname}>
        <Route path="/" element={<PageWrapper><Home /></PageWrapper>} />
        <Route path="/aboutus" element={<PageWrapper><AboutUs /></PageWrapper>} />
        <Route path="/accounts" element={<PageWrapper><AccountsTypes /></PageWrapper>} />
        <Route path="/markets" element={<PageWrapper><Markets /></PageWrapper>} />
        <Route path="/support" element={<PageWrapper><Support /></PageWrapper>} />
      </Routes>
    </AnimatePresence>
  );
}
